import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FungistLanding from "@/FungistLanding";
import NeoLibLanding from "@/NeoLibLanding";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FungistLanding />} />
        <Route path="/neo-lib" element={<NeoLibLanding />} />
        <Route path="/Neo-lib" element={<NeoLibLanding />} />
        <Route path="/Neo-Lib" element={<NeoLibLanding />} />
        <Route path="/NEO-LIB" element={<NeoLibLanding />} />
        <Route path="/neolib" element={<NeoLibLanding />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
